import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MultiButtonConfirmationModal from './multi-button-confirmation-modal';
import { setModalOpen } from '../../../stores/actions/modal';
import LoadingSpinner from '../../general-components/loading-spinner';
import Colors from '../../../utils/colors';
import { GreenroomState as GS } from '../../../stores/types/types';
import { ContentServiceJobStatus, RegeneratingContent } from '../../../stores/types/content';

interface GeneratedContentUpdatingProps {
	staleContent: RegeneratingContent[];
}

export default function GeneratedContentUpdating({ staleContent }: GeneratedContentUpdatingProps) {
	const dispatch = useDispatch();

	const generatedContent = useSelector((s: GS) => s.GeneratedContentReducer.generatedContent);

	function handleClose() {
		dispatch(setModalOpen(false));
	}

	useEffect(() => {
		// when all of the stale regenerating content is complete, close the modal
		const staleComplete = staleContent.every(s => generatedContent.some(c => {
			return c.id === s.id && c.version >= s.version && c.jobStatus === ContentServiceJobStatus.completed;
		}));
		if (staleComplete) {
			handleClose();
		}
	}, [generatedContent]);

	return (
		<MultiButtonConfirmationModal
			customHeader={
				<div style={{ position: 'relative' }}>
					<div style={{ position: 'absolute', left: '-9px', height: '60px' }}>
						<LoadingSpinner
							percHeight={100}
							percWidth={100}
							height={1000}
							width={1000}
							color={Colors.paleGreen}
							stroke={4}
						/>
					</div>
					<div className="margin-bottom-medium modal-header-container" style={{ marginTop: '71px' }}>
						<span className="text-white font-weight-bold font-size-16 modal-header-text">
							We are updating your assets
						</span>
					</div>
				</div>
			}
			bodyText="Some speaker’s information and/or theme settings have been updated. Closing this tab won’t affect the update."
			firstButtonText="Close"
			firstButtonAction={handleClose}
			className="generated-content-updating"
			isOpen
		/>
	);
}
